import React from 'react';
import { observer } from 'mobx-react';

import { UiIcon } from 'shared/uikit-new';
import { ROUTES } from 'shared/constants';
import { useNavigate } from 'shared/hooks';
import { ChatMessagesModule } from 'shared/modules';

import './styles.scss';

export const LayoutHeaderChatMessages = observer(() => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(ROUTES.CHATS());
    };

    return (
        <div className='layout-header-icon'>
            <div className='layout-header-icon__inner' onClick={handleClick}>
                <UiIcon.MessageCircle size={24} />
                {!!ChatMessagesModule.unreadCount && <div className='layout-header-icon__counter'>{ChatMessagesModule.unreadCount}</div>}
            </div>
        </div>
    );
});
